"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Payment = /*#__PURE__*/function () {
  function Payment(client) {
    (0, _classCallCheck2["default"])(this, Payment);
    this.client = client;
    this.resourceUrl = '/payment';
  }

  (0, _createClass2["default"])(Payment, [{
    key: "applyPromo",
    value: function applyPromo(data) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/apply-promo"), data, args);
    }
  }, {
    key: "pay",
    value: function pay(data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.post("".concat(this.resourceUrl, "/pay"), data, args);
    }
  }, {
    key: "getUserCardListing",
    value: function getUserCardListing() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/card-list"), args);
    }
  }, {
    key: "attachPayMethod",
    value: function attachPayMethod(data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl, "/attach-pay-method"), data, args);
    }
  }, {
    key: "detachCard",
    value: function detachCard(data) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.post("".concat(this.resourceUrl, "/detach-pay-method"), data, args);
    }
  }, {
    key: "getUserSubscriptionPayment",
    value: function getUserSubscriptionPayment(userId) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return this.client.get("".concat(this.resourceUrl, "/list-subscription?userId=").concat(userId), args);
    }
  }, {
    key: "getUserPayments",
    value: function getUserPayments(userId) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return this.client.get("".concat(this.resourceUrl, "/payment-history-list?clientId=").concat(userId), args);
    }
  }, {
    key: "changeSubscriptionCard",
    value: function changeSubscriptionCard(data) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        args[_key8 - 1] = arguments[_key8];
      }

      return this.client.post("".concat(this.resourceUrl, "/change-subscription-card"), data, args);
    }
  }, {
    key: "paySOW",
    value: function paySOW(data) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return this.client.post("".concat(this.resourceUrl, "/pay-sow"), data, args);
    }
  }, {
    key: "paySowWithoutCoach",
    value: function paySowWithoutCoach(data) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return this.client.post("".concat(this.resourceUrl, "/pay-sow-without-coach"), data, args);
    }
  }, {
    key: "getSubscription",
    value: function getSubscription(subscriptionId) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      return this.client.get("".concat(this.resourceUrl, "/sow-payment-data/").concat(subscriptionId), args);
    }
  }, {
    key: "confirmPayment",
    value: function confirmPayment(data) {
      var url = "".concat(this.resourceUrl, "/confirm-payment");

      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.post(url, data, args);
    }
  }, {
    key: "getCurrencyExchangeRate",
    value: function getCurrencyExchangeRate(from, to) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 2 ? _len13 - 2 : 0), _key13 = 2; _key13 < _len13; _key13++) {
        args[_key13 - 2] = arguments[_key13];
      }

      return this.client.get("".concat(this.resourceUrl, "/currency-exchange-rate?from=").concat(from, "&to=").concat(to), args);
    }
  }]);
  return Payment;
}();

exports["default"] = Payment;